import {connect} from 'react-redux'
import actions from 'redux-auto'
import AllNotifications from './index'

const mapStateToProps = state => ({
  permissions: state.authentication.permissions,
  allNotifications: state.benachrichtigungen.all,
})

const mapActionsToProps = () => ({
  loadNotifications: actions.benachrichtigungen.readBenachrichtigungen,
  readAll: actions.benachrichtigungen.markAllNotificationsAsRead,
  readOne: actions.benachrichtigungen.markAsRead,
  markAsUnread: actions.benachrichtigungen.markAsUnread,
})

export default connect(mapStateToProps, mapActionsToProps)(AllNotifications)
